





























































































































































































































import Vue from 'vue'
import i18n from '../i18n'
import { AttachmentInterface, LabelInterface, PostInterface, UploadInterface } from '@/types/interfaces'

import * as Trix from 'trix'
import 'trix/dist/trix.css'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {German} from 'flatpickr/dist/l10n/de.js'
import {english} from 'flatpickr/dist/l10n/default.js'
import Tagify from '@yaireo/tagify'
import '@yaireo/tagify/dist/tagify.css'
import draggable from 'vuedraggable'

import moment from 'moment'
import { generateRandomId } from '@/services/generateId'

import UiCard from '@/components/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiModal from '@/components/UiModal.vue'
import UiIcon from '@/components/UiIcon.vue'
import PostTweets from '@/components/PostTweets.vue'
import PostYoutubes from '@/components/PostYoutubes.vue'

import { VALID_MAXIMUM_UPLOAD_SIZE, VALID_MAXIMUM_UPLOAD_SIZE_SMALL, VALID_UPLOAD_FILE_TYPES, VALID_UPLOAD_IMAGE_TYPES } from '@/constants'
import { fileAdapter, dataUrlAdapter, imgAdapter, pdfAdapter } from '@/services/fileAdapter'
import { flattenedAttachments } from '@/services/flattenAttachments'


const _initPost = (initialPost? : PostInterface) : PostInterface => {
  let emptyPost  = {
    id: "",
    releasedAt: new Date(),
    createdAt: null,
    updatedAt: null,
    htmlBody: "",
    bodyAttachments: [],
    labelIds: [],
    authorUserId: "",
    authorUserName: "",
    attachments: [],
    socialAttachments: []
  } as PostInterface

  const post = (Object.keys(emptyPost) as Array<keyof typeof emptyPost>).reduce((newPost, key) => {
    // @ts-ignore
    newPost[key] = initialPost && initialPost[key] ? initialPost[key] : newPost[key]
    return newPost
  }, emptyPost)
  
  return post
}


export default Vue.extend({
  name: 'AuthorInput',
  props: { 
    initialPost: Object,
    onSubmitCallback: Function
  },
  data(){
    return {
      organizationId: this.$store.getters.organization.id,
      organizationLabels: this.$store.getters.organizationLabels,
      datePickerConfig: {
        altInput: true,
        altFormat: "F j, Y H:i",
        enableTime: true,
        time_24hr: true,
        locale: i18n.locale == "de" ? German : english
      },
      tagInputEl: null as any,
      postDraft: _initPost(this.initialPost),
      bodyAttachmentDrafts: [] as Array<{
        bodyAttachmentId: string,
        attachment: any,
      }>,
      socialDraft: {
        twitter: "",
        youtube: "",
      },
      newLabelDraft: "",
      loadingAttachments: [] as Array<string>,
      deletingAttachments: [] as Array<AttachmentInterface>,
      editLabelsShowId: "",
      isLoadingSubmit: false,
      editorFocus: false,
      shouldShowTwitterInput: false,
      shouldShowYoutubeInput: false,
      draggingFile: false,
      isEditingLabels: false,
      isSavingLabels: false,
    }
  },
  computed: {
    acceptedUploadString(){
      return VALID_UPLOAD_FILE_TYPES.map((fileType, i) => `.${fileType}`)
    },
    acceptedUploadStringLabelImg(){
      return VALID_UPLOAD_IMAGE_TYPES.map((fileType, i) => `.${fileType}`)
    },
    organizationLabelsAsArray: {
      get(): Array<LabelInterface>{
        return this.$store.getters.organizationLabelsAsArray
      },
      async set(value: Array<LabelInterface>){
        // This function is called when the order of labels changes (due to draggable)
        await this._updateOrganizationLabelPositionsFromArray(value)
      }
    }
  },
  methods: {
    isUpdatingPost(){
      return !!this.postDraft.id
    },
    isDateFuture(date: Date){
      return date > (this.$store.getters.serverTime || new Date())
    },
    isLabelNumberMoreThan5(){
      return this.organizationLabelsAsArray.length > 5
    },
    isLoadingAttachments(){
      return this.loadingAttachments.length > 0
    },
    focusEditor(event: any, editor: any){ // show editor toolbar on editor focus (and keep it visible on unfocus)
      this.editorFocus = true
    },
    editorToolbarClass(){
      return this.editorFocus ? "editor__toolbar--show" : "editor__toolbar--hide"
    },
    handleToggleLabelsEditor(){
      this.isEditingLabels = !this.isEditingLabels
    },
    handleFileDrag(event: any){
      event.preventDefault()
      if(!this._dragEventContainsFiles(event)) return
      this.draggingFile = true
    },
    handleFileDragEnd(event: any){
      event.preventDefault()
      if(!this._dragEventContainsFiles(event)) return
      this.draggingFile = false
    },
    async handleFileDrop(event: any){
      event.preventDefault()
      if(!this._dragEventContainsFiles(event)) return
      this.draggingFile = false
      const files: Array<File> = Array.from(event.dataTransfer.files)
      return await this._uploadFileAttachments(files)
    },
    handleEditorContentChange(event: any){ // Update data() from text editor
      this.postDraft.htmlBody = event.srcElement ? event.srcElement.value : event.target.value
    },
    async handleEditorFileAccept(event: any){
      // Only allow image file drops
      if(event.file?.type?.substring(0,5) != "image") return event.preventDefault()
    },
    async handleEditorFileAdd(event: any){
      const attachment: {
        file: File,
        setAttributes: Function,
        getAttribute: Function
      } = event.attachment

      // ONLY upload dragged in img files. If the HTML img was pasted in, use the external img URL and `return` here
      if(!attachment.file) return

      // Loading Spinner active
      const loadingId = new Date().toISOString()
      this.loadingAttachments = this.loadingAttachments.concat([loadingId])

      try {
        const imgFile = attachment.file

        const resizedImg = await imgAdapter.limitSize(imgFile, {height: 1440, width: 1024})
        const attachmentDraft = await this._generateAttachmentObj(resizedImg)

        // this.bodyAttachmentDrafts give us access to the attachment.setAttributes() method later so we can upload the images at once on post submit
        this.bodyAttachmentDrafts = this.bodyAttachmentDrafts.concat([{
          bodyAttachmentId: attachmentDraft.id,
          attachment: attachment,
        }])
        // Add images with Data URLs to postDraft
        this.postDraft.bodyAttachments = this.postDraft.bodyAttachments.concat([attachmentDraft])
        // TODO: Maybe we need error handling and remove the image if something went wrong?
      } catch (error) {
        console.error("ERROR attaching a file to the editor text", error)
        // Remove attachment from body in case something went wrong:
        event.attachment?.remove()
      } finally {
        // Always Remove loading element
        this.loadingAttachments = this.loadingAttachments.filter(a => a != loadingId)
      }
    },
    async handleEditorFileRemove(event: any){
      const attachment: {
        file: File,
        setAttributes: Function,
        getAttributes: Function,
        getAttribute: Function
      } = event.attachment

      const removedBodyAttachmentDraft = this.bodyAttachmentDrafts.find(draft => draft.attachment.getAttribute("url") == attachment?.getAttribute("url"))

      // Remove draft from list of files to upload:
      this.bodyAttachmentDrafts = this.bodyAttachmentDrafts.filter(draft => draft.bodyAttachmentId != removedBodyAttachmentDraft?.bodyAttachmentId)
      // Remove image from postDraft
      this.postDraft.bodyAttachments = this.postDraft.bodyAttachments.filter(a => a.id != removedBodyAttachmentDraft?.bodyAttachmentId)
    },
    handleLabelChange(e: any){ // Update data() from label input
      try {
        // Set postDraft labelIds as the IDs from the organization.
        // If a labelID does not exist on the organization, use the value instead. 
        // The value will be used during creation/update to create a new label on the organization
        this.postDraft.labelIds = e.target.value ? JSON.parse(e.target.value).map((l: LabelInterface) => l.id || l.value) : []
      } catch (error) { console.error("LABEL UPDATE ERROR", e.target.value) }
    },

    socialAttachmentsWithIndex(platform: string){
      return this.postDraft.socialAttachments.map((a, i) => {
        const attachmentWithIndex = Object.assign({}, a)
        attachmentWithIndex.index = i
        return attachmentWithIndex
      }).filter(a => a.platform == platform)
    },

    handleTwitterClick(){
      this.shouldShowYoutubeInput = false
      this.shouldShowTwitterInput = !this.shouldShowTwitterInput
      if(!this.shouldShowTwitterInput) this.socialDraft.twitter = ""
    },
    handleTwitterSubmit(){
      const matchedTwitterUrl = this.socialDraft.twitter.match(/(twitter\.com\/.*\/status\/)\d+/g)
      if(!matchedTwitterUrl) return alert(this.$t("error.invalidTwitter"))
      const twitterPostId = matchedTwitterUrl[0].split("/status/").reverse()[0]

      this.postDraft.socialAttachments = this.postDraft.socialAttachments.concat({
        platform: "twitter",
        reference: twitterPostId
      })
      this.socialDraft.twitter = ""
      this.shouldShowTwitterInput = false
    },

    handleYoutubeClick(){
      this.shouldShowTwitterInput = false
      this.shouldShowYoutubeInput = !this.shouldShowYoutubeInput
      if(!this.shouldShowYoutubeInput) this.socialDraft.youtube = ""
    },
    handleYoutubeSubmit(){
      const matchedYoutubeUrl = this.socialDraft.youtube.match(/youtube\.com\/watch\?v=.+/g)
      const matchedYoutubeUrlShort = this.socialDraft.youtube.match(/youtu\.be\/.+/g)
      if(
        !matchedYoutubeUrl &&
        !matchedYoutubeUrlShort
      ) return alert(this.$t("error.invalidYoutube"))
      
      const youtubeVideoId = matchedYoutubeUrlShort ? 
        matchedYoutubeUrlShort[0].split("/").reverse()[0] :
        new URL(this.socialDraft.youtube).searchParams.get("v")

      if(!youtubeVideoId) return alert(this.$t("error.invalidYoutube"))      

      this.postDraft.socialAttachments = this.postDraft.socialAttachments.concat({
        platform: "youtube",
        reference: youtubeVideoId
      })
      this.socialDraft.youtube = ""
      this.shouldShowYoutubeInput = false
    },
    handleDeleteSocialAttachment(positionIndex: number){
      const newSocialAttachments = this.postDraft.socialAttachments.slice()

      // TODO: Get position from actual object

      newSocialAttachments.splice(positionIndex, 1)
      this.postDraft.socialAttachments = newSocialAttachments
    },
    async handleUploadClick(event: any){
      ;(this.$refs.authorFileUpload as HTMLElement).click()
    },
    async handleUploadFileChange(event: any){
      const files: Array<File> = Array.from(event.target.files)
      return await this._uploadFileAttachments(files)
    },
    async handleAttachmentDeleteClick(attachment: AttachmentInterface){
      // Add attachment to a temporary list of attachments to delete 
      // (in case users edit a post, delete filtes, and navigate away from it without saving)
      this.deletingAttachments = [...this.deletingAttachments, attachment]
      // Remove attachment from the local attachment state
      this.postDraft.attachments = this.postDraft.attachments.filter(a => a.path != attachment.path)
    },
    async _deleteDeletingAttachments(){
      try {
        // Iterate over all attachment removed from the currently edit draft and actually delete them on the server:
        return Promise.all(this.deletingAttachments.map(attachment => {
          return this._handleAttachmentDelete(attachment)
        }))
      } catch (error) {
        alert(this.$t('error.deleteAttachmentFailed'))
      }
    },
    async _handleAttachmentDelete(attachment: AttachmentInterface){
      // 🚨 Recursive Function! Delete subattachments
      if(attachment.subAttachments) await Promise.all(attachment.subAttachments.map(subAttachment => {
        return this._handleAttachmentDelete(subAttachment)
      }))
      // Delete this attachment
      await this.$store.dispatch('removePostAttachment', attachment.path)
    },
    async handleAuthorSubmit(){
      // Check for presence of article contents:
      if(
        !this.postDraft.htmlBody && 
        !(this.postDraft.attachments.length > 0) &&
        !(this.postDraft.socialAttachments.length > 0)
      ) return alert(this.$t('error.submissionEmpty'))

      try {
        this.isLoadingSubmit = true
        // Set Author data on post draft
        this._setAuthorData()

        // Upload all bodyAttachments
        await this._uploadBodyAttachments()

        // Delete all attachment marked for deleting:
        await this._deleteDeletingAttachments()

        // Submit Post OR update post
        if(this.isUpdatingPost()) await this.$store.dispatch('updatePost', this.postDraft)
        else                      await this.$store.dispatch('createPost', this.postDraft)
        // Reset post draft
        this.postDraft = _initPost()
        // Update server time
        await this.$store.dispatch('setServerTime')
        // Remove draft from local storage
        window.localStorage.removeItem("postDraft")
        // reload all posts
        await this.onSubmitCallback()

        this.isLoadingSubmit = false
      } catch (error) {
        this.isLoadingSubmit = false
        console.error(error)
        alert(this.$t('error.submitFailed'))
      }
    },
    selectAttachedImages(attachments: Array<AttachmentInterface>){
      return attachments.filter(attachment => attachment.type == "image")
    },
    selectAttachedPdfs(attachments: Array<AttachmentInterface>){
      return attachments.filter(attachment => attachment.type == "pdf")
    },

    async handleLabelEditNew(){
      // Validate the field isn't empty
      if(this.newLabelDraft.trim().length == 0) return alert(this.$t('error.editLabels.newLabelEmpty'))
      // Validate the name isn't used yet
      if(this.organizationLabelsAsArray.map(label => label.value).includes(this.newLabelDraft.trim())) return alert(this.$t('error.editLabels.newLabelTaken'))

      // Add new label
      const newLabel : LabelInterface = {
        id: generateRandomId(),
        value: this.newLabelDraft.trim(),
        img: null,
        isDeleted: false,
        position: this.organizationLabelsAsArray.length + 1
      }

      await this._updateOrganizationLabel(newLabel)
      this.newLabelDraft = ''
      this.scrollToNewLabel()
      return
    },

    navigateToLabelId(labelId: string){
      return this.$router.push({ name: 'OrganizationFeed', params: { organizationId: this.organizationId }, query: {labelIds: labelId} })
    },
    async handleEditLabelInputFocus(label: LabelInterface){
      // Show link to view related posts
      this.editLabelsShowId = label.id
    },
    async handleEditLabelInputBlur(label: LabelInterface, targetValue: string){
      await this.handleLabelsEditName(label, targetValue)
      this.editLabelsShowId = "" // Hide link to view related posts
    },

    async handleLabelsEditName(label: LabelInterface, value: string){
      const newLabel = Object.assign({}, label)
      newLabel.value = value
      
      // Don't submit update if nothing changed
      if(label.value == newLabel.value) return
      
      return await this._updateOrganizationLabel(newLabel)
    },
    async handleLabelsEditDelete(label: LabelInterface){
      if(!confirm(this.$t('editLabels.deleteLabelConfirm').toString())) return

      const newLabel = Object.assign({}, label)
      newLabel.isDeleted = true
      newLabel.position = 0

      return await this._updateOrganizationLabel(newLabel)
    },
    async handleLabelsEditUploadImg(id: string){
      ;(this.$refs[`editLabelsFileUpload_${id}`] as Array<HTMLElement>)[0].click()
    },
    async handleEditLabelUploadFileChange(label: LabelInterface, event: any){
      const files: Array<File> = Array.from(event.target.files)

      // Check if file present:
      if(files.length == 0) return

      // Set loading 
      this.isSavingLabels = true

      try {
        // Validate file size below 1MB:
        if(files.some((f:File) => f.size > VALID_MAXIMUM_UPLOAD_SIZE_SMALL)) 
          throw({displayError: this.$t("error.editLabels.fileTooLarge")})
        // Validate file types:
        if(files.some((f:File) => {
          return !VALID_UPLOAD_IMAGE_TYPES.includes(this._getFileExtension(f))
        }))
          throw({displayError: this.$t("error.editLabels.fileWrongType")})

        const file = files[0]
        // Rename file in order to replace upload when the label icon changes
        const fileExt = file.name.split('.').pop()
        const renamedFile = fileAdapter.rename(file, `${label.id}.${fileExt}`)

        // Resize file to max 150x150
        const reducedFile = await imgAdapter.limitSize(renamedFile, {height: 150, width: 150})

        // Start file upload
        const uploadResponse : UploadInterface = await this.$store.dispatch('uploadOrganizationLabelImg', {
          file: reducedFile,
          path: this._generateLabelImgPath(
            reducedFile,
            label.id,
            this.$store.getters.organizationShortId
          )
        })

        // After successful upload update the organization labels
        const newLabel = Object.assign({}, label)
        newLabel.img = uploadResponse.publicURL

        await this._updateOrganizationLabel(newLabel)

        // Reset file upload field
        ;(this.$refs[`editLabelsFileUpload_${label.id}`] as Array<HTMLInputElement>)[0].value = ''

        // Unset loading
        this.isSavingLabels = false
        return
      } catch (error) {
        console.error(error)
        if(error.displayError) alert(error.displayError)
      }
    },

    scrollToNewLabel() {
      const el = this.$el.getElementsByClassName('editLabels__new')[0]
      if (el && el.scrollIntoView) el.scrollIntoView({behavior: 'smooth'})
    },

    async _updateOrganizationLabel(label: LabelInterface){
      this.isSavingLabels = true
      await this.$store.dispatch('updateOrganizationLabel', label)
      this._reloadLabelsInput()
      this.isSavingLabels = false
    },
    async _updateOrganizationLabelPositionsFromArray(labels: Array<LabelInterface>){
      this.isSavingLabels = true

      // Convert labels array to object:
      const newLabelPositions = labels.reduce((labelPositions: {[key: string]: number}, label: LabelInterface, i) => {
        const newObj = Object.assign({}, label)
        labelPositions[label.id] = newObj.position = i + 1 // Set new position in case of reordering
        return labelPositions
      }, {})
      // Submit changes:
      await this.$store.dispatch('updateLabelPositions', newLabelPositions)
      // Update label suggestions
      this._reloadLabelsInput()

      this.isSavingLabels = false
    },
    _reloadLabelsInput(){
      // Update label suggestions
      this.tagInputEl.settings.whitelist = this.organizationLabelsAsArray
      // Remove ONLY a label from input field if that label was just removed:
      const newLabelIds = this.postDraft.labelIds.slice().filter(id => this.organizationLabelsAsArray.map(label => label.id).includes(id) )
      const newLabelsAsArray = this._labelIdsToObjs(newLabelIds)

      this.tagInputEl.removeAllTags()
      this.tagInputEl.addTags(newLabelsAsArray)
      this.postDraft.labelIds = newLabelIds
    },
    _dragEventContainsFiles(event: any){
      return Array.from(event.dataTransfer.types).includes("Files")
    },
    async _uploadBodyAttachments(){
      const notYetUploadedAttachments = this.postDraft.bodyAttachments.filter(a => a.file)
      // Don't upload anything if all existing files already have URLs
      if(!notYetUploadedAttachments) return

      // Start file upload
      const uploadedAttachments = await this._uploadAttachments(notYetUploadedAttachments)

      // After successful upload update files in postDraft with the correct uploaded file paths:
      const updatedAttachments = this._updateDraftAttachmentsFromUploads(notYetUploadedAttachments, uploadedAttachments)

      updatedAttachments.forEach(attachmentDraft => {
        const indexInAttachments = this.postDraft.bodyAttachments.findIndex(a => a.id == attachmentDraft.id)
        this.postDraft.bodyAttachments[indexInAttachments] = attachmentDraft
      })

      // Update all the attachments in the HTML body: 
      updatedAttachments.forEach(attachmentDraft => {
        const bodyAttachmentDraft = this.bodyAttachmentDrafts.find(draft => draft.bodyAttachmentId == attachmentDraft.id)
        if(!bodyAttachmentDraft) {
          console.error("Error in handleAuthorSubmit: Could not find bodyattachment for ID ", attachmentDraft.id)
          return
        }

        bodyAttachmentDraft.attachment.setAttributes({
          url: attachmentDraft.downloadUrl,
          path: attachmentDraft.path,
        })
      })

      // Reset list of files to upload:
      this.bodyAttachmentDrafts = []
    },
    async _uploadFileAttachments(files: Array<File>){
      // Check if file present:
      if(files.length == 0) return
      // Set loading 
      const loadingId = new Date().toISOString()
      this.loadingAttachments = this.loadingAttachments.concat([loadingId])
      try {
        // Validate file size below 10MB:
        if(files.some((f:File) => f.size > VALID_MAXIMUM_UPLOAD_SIZE)) 
          throw({displayError: this.$t("error.fileTooLarge")})
        // Validate file types:
        if(files.some((f:File) => {
          return !VALID_UPLOAD_FILE_TYPES.includes(this._getFileExtension(f))
        }))
          throw({displayError: this.$t("error.fileWrongType")})
        
        // Add preview of uploading files to postDraft
        const attachmentsDraft = await Promise.all(files.map(async (f:File): Promise<AttachmentInterface> => {
          return this._generateAttachmentObj(f)
        }))
        this.postDraft.attachments = this.postDraft.attachments.concat(attachmentsDraft)

        // Start file upload
        const uploadedAttachments = await this._uploadAttachments(attachmentsDraft)

        // After successful upload update files in postDraft with the correct uploaded file paths:
        const updatedAttachments = this._updateDraftAttachmentsFromUploads(attachmentsDraft, uploadedAttachments)

        updatedAttachments.forEach(attachmentDraft => {
          const indexInAttachments = this.postDraft.attachments.findIndex(a => a.id == attachmentDraft.id)
          this.postDraft.attachments[indexInAttachments] = attachmentDraft
        })
        
        // Reset file upload field
        ;(this.$refs.authorFileUpload as HTMLInputElement).value = ''
      } catch (error) {
        console.error(error)
        if(error.displayError) alert(error.displayError)
      }
      // Unset loading
      this.loadingAttachments = this.loadingAttachments.filter(a => a != loadingId)
    },
    async _deleteFileAttachments(){

    },
    _setAuthorData(){
      this.postDraft.authorUserId = this.$store.getters.userId
      this.postDraft.authorUserName = this.$store.getters.userName || this.$t('anonymousFallback') // TODO: Make sure users have names
    },
    _getFileExtension(file: File){
      return file.name.split('.').pop()?.toLowerCase() || ""
    },
    _generateFileId(){
      return `${moment().format('YYYYMMDDHHmmss')}-${this.$store.getters.userId.substring(0,5)}-${generateRandomId()}`
    },
    _generateAttachmentPath(file: File, fileId: string, organizationShortId: string){
      const fileExt = file.name.split('.').pop()
      return `${organizationShortId}/posts/attachments/${fileId}.${fileExt}`
    },
    _generateLabelImgPath(file: File, fileId: string, organizationShortId: string){
      const fileExt = file.name.split('.').pop()
      return `${organizationShortId}/labels/img/${fileId}.${fileExt}`
    },

    async _generateAttachmentObj(file: File){
      const id = this._generateFileId()
      
      // Extra Arrays specifically for PDFs / Technically not relevant for images
      const fileAsImgUrls : Array<string> = fileAdapter.isPdf(file) ? 
        await pdfAdapter.getPagesAsImageDataUrls(file) :
        [await fileAdapter.asDataUrl(file)]

      // Generate file objects for each individual PDF page as image: (or return just the `file` if it's an image)
      const imgUrlsAsFiles : Array<File> = fileAdapter.isPdf(file) ? 
        await Promise.all(fileAsImgUrls.map((url,i) => dataUrlAdapter.asFile(url, `${id}_${i}.jpg`))) :
        [file]
      
      // 🚨 Recursive Function! The following call should only be made if we are sure `imgUrlsAsFiles` only contains image files!
      const subAttachments : Array<AttachmentInterface> = fileAdapter.isPdf(file) ? 
        await Promise.all(imgUrlsAsFiles.map(file => this._generateAttachmentObj(file))) :
        []

      const type = fileAdapter.isPdf(file) ? "pdf" : "image"
      const metadata = await imgAdapter.getHeightAndWidth(
        fileAdapter.isPdf(file) ? imgUrlsAsFiles[0] : file
      )
      const preview = fileAsImgUrls[0]
      const path = this._generateAttachmentPath(file, id, this.$store.getters.organizationShortId)

      return {
        id,
        type,
        path,
        preview,
        metadata,
        subAttachments,
        downloadUrl: "", // must be filled after upload 👇
        status: "pending",
        file: file,
      }
    },

    async _uploadAttachments(attachments: Array<AttachmentInterface>) : Promise<Array<UploadInterface>>{
      return await Promise.all(
        flattenedAttachments(attachments).map((attachment: AttachmentInterface) => {
          return this.$store.dispatch('addPostAttachment', attachment)
        })
      )
    },

    _updateDraftAttachmentsFromUploads(draftAttachments: Array<AttachmentInterface>, uploads: Array<UploadInterface>){
      return draftAttachments.map(attachment => {
        const upload = uploads.find(a => a.name.split('.')[0] == attachment.id)
        if(!upload) throw("No upload found for given attachment!")

        // 🚨 Recursive Function!
        attachment.subAttachments = attachment.subAttachments ? 
          this._updateDraftAttachmentsFromUploads(attachment.subAttachments, uploads) :
          []

        attachment.path = upload.path
        attachment.status = upload.state
        attachment.downloadUrl = upload.publicURL
        attachment.preview = (attachment.type == "pdf" && attachment.subAttachments) ?
          attachment.subAttachments[0].preview :
          upload.publicURL

        return attachment
      })
    },

    _labelIdToObj(id: string){
      const organizationLabelObj = this.$store.getters.organization.labels[id]
      return organizationLabelObj || null
    },
    _labelIdsToObjs(ids: Array<string>){
      return ids.map(id => this._labelIdToObj(id)).filter(label => label != null)
    }
  },
  mounted(){
    // Initialize Tagify (for author input labels)
    const $component = this
    const labels = this.organizationLabelsAsArray
    
    this.tagInputEl = new Tagify(this.$refs.authorLabelInput, {
      whitelist: labels,
      enforceWhitelist: true,
      editTags: false,
      skipInvalid: true,
      autoComplete: {
        rightKey: true
      },
      dropdown: {
        enabled: 0,
        maxItems: 10,
        className: "authorLabelDropdown",
        closeOnSelect: false
      },
      templates: {
        tag(data: any) : any {
          try {
            // @ts-ignore
            return `<tag title='${data.value}' contenteditable='false' spellcheck="false" class='tagify__tag ${data.class ? data.class : ""}' ${this.getAttributes(data)}>
                      <x title='remove tag' class='tagify__tag__removeBtn'></x>
                      <div>
                        ${data.img ?
                        `<img onerror="this.style.visibility='hidden'" src='${data.img}'>` : '<span class="authorInput__label__spacer"></span>'
                        }
                        <span class='tagify__tag-text'>${data.value}</span>
                      </div>
                    </tag>`
          } catch(err){}
        },
        dropdownItem(data: any){
          try{
          return `<div class='tagify__dropdown__item ${data.class ? data.class : ""}' tagifySuggestionIdx="${data.tagifySuggestionIdx}">
                    ${data.img ?
                    `<img onerror="this.style.visibility='hidden'" src='${data.img}'>` : ''
                    }
                    <span>${data.value}</span>
                  </div>`
          } catch(err){}
        },
        dropdownItemNoMatch(data: any){
          return $component.$t('labelNotFound', {label: data.value})
        }
      }
    })

    // Load labels when editing a post:
    this.tagInputEl.addTags(
      this._labelIdsToObjs(this.postDraft.labelIds)
    )

    // Trix Editor config (remove filename and size in case of empty captions)
    Trix.config.attachments.preview.caption = { name: false, size: false }
  },
  watch: {
    "postDraft": function(newVersion, oldVersion){ // runs when this.postDraft changes completely (for example when submitting)
      // Reload text editor
      const $authorBodyInput : any = this.$refs.authorBodyInput
      $authorBodyInput.editor.loadHTML(this.postDraft.htmlBody)

      // Reload tags
      this.tagInputEl.removeAllTags()
      this.tagInputEl.addTags(
        this._labelIdsToObjs(this.postDraft.labelIds)
      )
    },
  },
  components: {
    flatPickr,
    UiCard,
    UiButton,
    UiModal,
    UiIcon,
    PostTweets,
    PostYoutubes,
    draggable,
  }
})
